import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import toggleButton from 'vue-js-toggle-button'
import VueRadioToggleButtons from 'vue-radio-toggle-buttons';
import 'vue-radio-toggle-buttons/dist/vue-radio-toggle-buttons.css';
import VModal from 'vue-js-modal'
import VueScrollTo from 'vue-scrollto'
import Paginate from 'vuejs-paginate'
import axios from './axios'
import VueAxios from 'vue-axios'
import Vuelidate from 'vuelidate'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import VueLoaders from 'vue-loaders'
import 'vue-loaders/dist/vue-loaders.css'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VTooltip from 'v-tooltip'

import Icon from './components/Icon.vue'
import Tooltip from './components/Tooltip.vue'
import Button from './components/Button.vue'
import Checkbox from './components/Checkbox.vue'
import RadioToggleButtons from './components/RadioToggleButtons';
import LoadingLinear from './components/LoadingLinear.vue'
import dayjs from './dayjs'
import mdiVue from 'mdi-vue/v2';
import * as mdijs from '@mdi/js';

import './filters'
import './toast'
import helpers from './helpers'

Vue.config.productionTip = false

Vue.use(toggleButton)
Vue.use(VueRadioToggleButtons);
Vue.use(VModal, { dialog: true })
Vue.use(VueScrollTo)
Vue.component('paginate', Paginate)
Vue.use(VueAxios, axios)
Vue.use(Vuelidate)
Vue.component('v-select', vSelect)
Vue.use(VueGoodTablePlugin);
Vue.use(VueLoaders)
Vue.use(VueVirtualScroller);
Vue.use(VTooltip);
Vue.use(require('vue-moment'))
Vue.use(helpers)
Vue.use(mdiVue, { icons: mdijs });
Vue.component('Icon', Icon)
Vue.component('Tooltip', Tooltip)
Vue.component('Button', Button)
Vue.component('Checkbox', Checkbox)
Vue.component('PochiRadioToggleButtons', RadioToggleButtons)
Vue.component('LoadingLinear', LoadingLinear)
Vue.prototype.$dayjs = dayjs

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
